import { IPagedRequest } from "./request.model";

export interface IThemeImage {
  imageS3Key: string
  signedUrl: string
  signedUrlExpiry: Date
  lastSignedUrlGenerated: Date

  // fileName: string
  // uploadDate: string
}

export interface IThemeReq extends IPagedRequest {
  isActive?: boolean | null;
  includeDeleted?: boolean;
}

export interface ICreateThemeReq{
  name: string
  description: string
  interestsCount: number
  participantsCount: number
  entryFee: number
  participantsGender: 'male' | 'female'
  isActive: boolean
  image: File | null
  startDate?: string | Date | null
  questionGroup?: string | null
  roundsPerInterest?: number | null
  genericQuestions?: string[] | null
  genericQuestionsDuration?: number | null
}

export interface IUpdateThemeReq{
  id: string
  name?: string | null
  image?: File | null
  isActive?: boolean | null
  startDate?: string | Date | null
  questionGroup?: string | null
  roundsPerInterest?: number | null
  genericQuestions?: string[] | null
  genericQuestionsDuration?: number | null
}

export interface IThemeDataRes {
  items: ITheme[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface ITheme {
  _id: string;
  name: string;
  description?: string;
  isActive: boolean
  visibility: string
  createdBy: string // GUID as string
  image?: IThemeImage;
  status?: "active" | "inactive" | string;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  __v: number
  defaults?: IThemeDefault | null
  selected: boolean
}

export interface IThemeDefault{
  interestsCount?: number | null
  participantsCount?: number | null
  entryFee?: number | null
  participantsGender: string
  startDate?: string | Date | null
  questionGroup?: string | null
  roundsPerInterest?: number | null
  genericQuestionsDuration?: number | null
}

export enum ThemeStatus{
  Active = "Active",
  Inactive = "Inactive"
}
export interface IDeleteTheme_Response {
  success: boolean;
  message: string;
}